/*
  tipologia orario
  1 => 'Convivenza'
  2 => 'Convivenza Ridotta'
  3 => 'Non Conviventi (Full time, part time, a ore)'
  4 => 'Presenza notturna'
  5 => 'WeekEnd'
  6 => 'Assistenza Notturna'
*/

export const CONVIVENZA = 1;
export const CONVIVENZA_RIDOTTA = 2;
export const NON_CONVIVENTI = 3;
export const PRESENZA_NOTTURNA = 4;
export const WEEKEND = 5;
export const ASSISTENZA_NOTTURNA = 6;

export const NAME_TIPOLOGIA_ORARIO = {
  convivenza: 'Convivenza',
  convivenzaRidotta: 'Convivenza ridotta',
  nonConviventi: 'Full-time / part-time / a ore',
  presenzaNotturna: 'Presenza notturna',
  weekend: 'Weekend',
  assistenzaNotturna: 'Assistenza notturna',
};
